import { render, staticRenderFns } from "./IndxHead.vue?vue&type=template&id=06dba219&scoped=true"
import script from "./IndxHead.vue?vue&type=script&lang=js"
export * from "./IndxHead.vue?vue&type=script&lang=js"
import style0 from "./IndxHead.vue?vue&type=style&index=0&id=06dba219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dba219",
  null
  
)

export default component.exports